import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACMissingContentError = ({
  'data-test-id': dataTestId = 'missing-content-error',
  href,
  showLink = true,
  to = '/'
}) => /*#__PURE__*/_jsxs(ErrorMessage, {
  "data-test-id": dataTestId,
  type: "notFound",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.subheading"
    })
  }), showLink && (href ? /*#__PURE__*/_jsx(Button, {
    href: href,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  }) : /*#__PURE__*/_jsx(RouterButton, {
    to: to,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  }))]
});
export default ACMissingContentError;